module.exports = __webpack_public_path__ + "img/covid.09066aeb.jpg";